import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ProcessStep {
  phase: string;
  title: string;
  description: string;
  duration: string;
  icon: string;
}

interface ImplementationProcessProps {
  steps: ProcessStep[];
}

const ImplementationProcess = ({ steps }: ImplementationProcessProps) => {
  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Implementatieproces
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Van eerste assessment tot volledige deployment in duidelijke stappen
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-secondary hidden lg:block"></div>
            
            <div className="space-y-12">
              {steps.map((step, index) => (
                <div key={index} className="relative">
                  <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-4 lg:space-y-0 lg:space-x-8">
                    <div className="relative flex-shrink-0">
                      <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl"></div>
                      <div className="relative w-16 h-16 bg-gradient-to-br from-primary to-secondary rounded-full flex items-center justify-center border-4 border-background">
                        <Icon name={step.icon as any} size={28} className="text-background" />
                      </div>
                    </div>
                    
                    <div className="flex-1 glassmorphic rounded-xl p-6 lg:p-8">
                      <div className="flex flex-wrap items-center justify-between mb-3">
                        <div className="flex items-center space-x-3">
                          <span className="text-sm font-mono font-semibold text-primary">
                            {step.phase}
                          </span>
                          <span className="text-xs text-muted-foreground">•</span>
                          <span className="text-sm text-muted-foreground">{step.duration}</span>
                        </div>
                      </div>
                      
                      <h3 className="text-xl font-display font-bold text-foreground mb-3">
                        {step.title}
                      </h3>
                      
                      <p className="text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImplementationProcess;